import { CheckoutState, CheckoutResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { checkoutOrder } from './checkout.services';

export const initialState: CheckoutState = {
    data: {} as CheckoutResponse,
    status: "loading",
    error: {}
}

export const PaymentMethodSlice = createSlice({
    name: 'paymentmethod',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checkoutOrder.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(checkoutOrder.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(checkoutOrder.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const PaymentMethodReducer = PaymentMethodSlice.reducer